export const notificationDefaultDuration: number = 5000;
